/* HANS DENNEMARK — Theme interactions (Shopify) */
(function () {
  "use strict";

  /* ---- Scroll reveal ---- */
  const reveals = document.querySelectorAll(".reveal");
  if ("IntersectionObserver" in window && reveals.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add("in-view"); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add("in-view"));
  }

  /* ---- Product tabs ---- */
  document.querySelectorAll("[data-tabs]").forEach((wrap) => {
    const btns = wrap.querySelectorAll(".tab-btn");
    const panels = wrap.querySelectorAll(".tab-panel");
    btns.forEach((btn) => btn.addEventListener("click", () => {
      const id = btn.getAttribute("data-tab");
      btns.forEach((b) => b.classList.toggle("active", b === btn));
      panels.forEach((p) => p.classList.toggle("active", p.getAttribute("data-panel") === id));
    }));
  });

  /* ---- PDP gallery thumbs ---- */
  const mainImg = document.querySelector("[data-pdp-main]");
  if (mainImg) {
    document.querySelectorAll("[data-pdp-thumb]").forEach((t) => {
      t.addEventListener("click", () => {
        mainImg.src = t.dataset.full || t.src;
        document.querySelectorAll("[data-pdp-thumb]").forEach((x) => x.classList.remove("active"));
        t.classList.add("active");
      });
    });
  }

  /* ---- Quantity ---- */
  document.querySelectorAll("[data-qty]").forEach((q) => {
    const input = q.querySelector("input");
    q.querySelector("[data-qty-minus]")?.addEventListener("click", () => {
      input.value = Math.max(1, (parseInt(input.value) || 1) - 1);
    });
    q.querySelector("[data-qty-plus]")?.addEventListener("click", () => {
      input.value = (parseInt(input.value) || 1) + 1;
    });
  });

  /* ---- Mobile menu ---- */
  const burger = document.querySelector("[data-burger]");
  const mnav = document.querySelector("[data-mobile-nav]");
  if (burger && mnav) {
    burger.addEventListener("click", () => mnav.classList.toggle("open"));
  }

  /* ---- Cart drawer ---- */
  const drawer = document.querySelector("[data-cart-drawer]");
  const overlay = document.querySelector("[data-cart-overlay]");
  const openCart = () => { drawer?.classList.add("open"); overlay?.classList.add("open"); };
  const closeCart = () => { drawer?.classList.remove("open"); overlay?.classList.remove("open"); };
  document.querySelectorAll("[data-cart-open]").forEach((b) => b.addEventListener("click", (e) => { e.preventDefault(); openCart(); refreshCart(); }));
  document.querySelectorAll("[data-cart-close]").forEach((b) => b.addEventListener("click", closeCart));
  overlay?.addEventListener("click", closeCart);

  function fmt(cents) {
    return (cents / 100).toLocaleString("de-DE", { minimumFractionDigits: 2 }) + " €";
  }

  function refreshCart() {
    fetch("/cart.js").then((r) => r.json()).then((cart) => {
      document.querySelectorAll("[data-cart-count]").forEach((el) => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? "flex" : "none";
      });
      const body = document.querySelector("[data-cart-body]");
      const totalEl = document.querySelector("[data-cart-total]");
      if (totalEl) totalEl.textContent = fmt(cart.total_price);
      const prog = document.querySelector("[data-ship-progress]");
      if (prog) {
        const th = parseInt(prog.dataset.threshold || "10000", 10);
        const lbl = prog.querySelector("[data-ship-label]");
        const bar = prog.querySelector("[data-ship-bar]");
        if (cart.item_count === 0 || th <= 0) { prog.hidden = true; }
        else {
          prog.hidden = false;
          const rest = th - cart.total_price;
          bar.style.width = Math.min(100, (cart.total_price / th) * 100) + "%";
          if (rest > 0) { prog.classList.remove("is-done"); lbl.innerHTML = "Noch <b>" + fmt(rest) + "</b> bis zum Gratisversand (DE)"; }
          else { prog.classList.add("is-done"); lbl.innerHTML = "<b>✓ Gratisversand</b> innerhalb Deutschlands erreicht!"; }
        }
      }
      loadUpsells(cart);
      if (!body) return;
      if (cart.item_count === 0) {
        body.innerHTML = '<div class="cart-empty">Ihr Warenkorb ist noch leer.</div>';
        return;
      }
      body.innerHTML = cart.items.map((i) => `
        <div class="cart-line">
          <img src="${i.image ? i.image.replace(/(\.[^.]+)$/, "_120x$1") : ""}" alt="${i.product_title}">
          <div style="flex:1">
            <b>${i.product_title}</b>
            <span>${i.quantity} × ${fmt(i.final_price)}</span>
          </div>
          <b>${fmt(i.final_line_price)}</b>
        </div>`).join("");
    });
  }

  function centify(v) {
    const s = String(v);
    return s.includes(".") ? Math.round(parseFloat(s) * 100) : parseInt(s, 10);
  }

  function loadUpsells(cart) {
    const box = document.querySelector("[data-cart-upsell]");
    if (!box) return;
    if (cart.item_count === 0) { box.hidden = true; return; }
    const inCart = cart.items.map((i) => i.product_id);
    const renderUpsells = (prods) => {
      prods = (prods || []).filter((p) => !inCart.includes(p.id)).slice(0, 3);
      const list = box.querySelector("[data-upsell-list]");
      if (!prods.length) { box.hidden = true; return; }
      box.hidden = false;
      list.innerHTML = prods.map((p) => {
        const v = p.variants && p.variants[0];
        if (!v) return "";
        let img = p.featured_image || (p.images && p.images[0] && (p.images[0].src || p.images[0])) || "";
        if (img) img = img.replace(/(\.[^.\/]+)(\?.*)?$/, "_120x$1");
        return `
        <div class="cart-upsell__item">
          <img src="${img}" alt="" loading="lazy">
          <div class="cart-upsell__info"><b>${p.title}</b><span>${fmt(centify(v.price))}</span></div>
          <button type="button" class="cart-upsell__add" data-upsell-variant="${v.id}" aria-label="${p.title} hinzufügen">+</button>
        </div>`;
      }).join("");
      list.querySelectorAll("[data-upsell-variant]").forEach((b) => b.addEventListener("click", () => {
        b.disabled = true;
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: parseInt(b.dataset.upsellVariant, 10), quantity: 1 }),
        })
          .then((r) => r.json())
          .then(() => { refreshCart(); toast("Zum Warenkorb hinzugefügt"); })
          .catch(() => { b.disabled = false; });
      }));
    };
    fetch(`/recommendations/products.json?product_id=${cart.items[0].product_id}&limit=6`)
      .then((r) => (r.ok ? r.json() : { products: [] }))
      .then((d) => {
        if (d.products && d.products.length) { renderUpsells(d.products); return; }
        const handle = box.dataset.collection;
        if (!handle) { box.hidden = true; return; }
        fetch(`/collections/${handle}/products.json?limit=6`)
          .then((r2) => (r2.ok ? r2.json() : { products: [] }))
          .then((d2) => renderUpsells(d2.products))
          .catch(() => { box.hidden = true; });
      })
      .catch(() => { box.hidden = true; });
  }

  /* ---- Add to cart (AJAX) ---- */
  document.querySelectorAll("[data-add-to-cart]").forEach((form) => {
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      const btn = form.querySelector("[type=submit]");
      const original = btn ? btn.innerHTML : "";
      if (btn) { btn.disabled = true; btn.innerHTML = "Wird hinzugefügt…"; }
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: form.querySelector("[name=id]").value,
          quantity: parseInt(form.querySelector("[name=quantity]")?.value || 1),
        }),
      })
        .then((r) => r.json())
        .then(() => { refreshCart(); openCart(); toast("Zum Warenkorb hinzugefügt"); })
        .catch(() => toast("Etwas ist schiefgelaufen"))
        .finally(() => { if (btn) { btn.disabled = false; btn.innerHTML = original; } });
    });
  });

  let toastTimer;
  function toast(msg) {
    let t = document.querySelector(".toast");
    if (!t) {
      t = document.createElement("div");
      t.className = "toast";
      t.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 6L9 17l-5-5"/></svg><span></span>';
      document.body.appendChild(t);
    }
    t.querySelector("span").textContent = msg;
    t.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove("show"), 2600);
  }

  /* ---- Header predictive search (Dropdown, ohne Unterseite) ---- */
  (function initSearch(){
    const toggle = document.querySelector("[data-search-toggle]");
    const panel = document.querySelector("[data-search-panel]");
    if (!toggle || !panel) return;
    const input = panel.querySelector("[data-search-input]");
    const results = panel.querySelector("[data-search-results]");
    const form = panel.querySelector("form");
    let t;
    const open = () => { panel.hidden = false; setTimeout(() => input && input.focus(), 30); };
    const close = () => { panel.hidden = true; };
    toggle.addEventListener("click", (e) => { e.preventDefault(); panel.hidden ? open() : close(); });
    panel.querySelector("[data-search-close]")?.addEventListener("click", close);
    document.addEventListener("keydown", (e) => { if (e.key === "Escape") close(); });
    document.addEventListener("click", (e) => {
      if (!panel.hidden && !panel.contains(e.target) && !toggle.contains(e.target)) close();
    });
    const money = (v) => (typeof v === "number" ? fmt(v) : (v || ""));
    const render = (products, q) => {
      if (!products.length) { results.innerHTML = '<div class="hs-msg">Keine Treffer für „' + q + '".</div>'; return; }
      results.innerHTML = products.map((p) => {
        let img = (p.featured_image && (p.featured_image.url || p.featured_image)) || p.image || "";
        if (img) img = String(img).replace(/(\.[^.\/?]+)(\?.*)?$/, "_120x$1");
        const sub = p.product_type || p.vendor || "";
        const price = (p.price != null) ? '<span class="hs-result__p">' + money(p.price) + "</span>" : "";
        return '<a class="hs-result" href="' + p.url + '">' +
          (img ? '<img src="' + img + '" alt="" loading="lazy">' : "") +
          '<span><span class="hs-result__t">' + p.title + "</span>" +
          (sub ? '<br><span class="hs-result__s">' + sub + "</span>" : "") + "</span>" +
          price + "</a>";
      }).join("") + '<a class="hs-all" href="' + form.action + "?q=" + encodeURIComponent(q) + '">Alle Ergebnisse anzeigen →</a>';
    };
    input && input.addEventListener("input", () => {
      const q = input.value.trim();
      clearTimeout(t);
      if (q.length < 2) { results.innerHTML = ""; return; }
      t = setTimeout(() => {
        fetch("/search/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last")
          .then((r) => r.json())
          .then((d) => render((d.resources && d.resources.results && d.resources.results.products) || [], q))
          .catch(() => { results.innerHTML = '<div class="hs-msg">Suche momentan nicht verfügbar.</div>'; });
      }, 220);
    });
  })();

  refreshCart();
})();
